import {ICardProps} from "@housebets/housebets-x-package/lib/components/cards/Card/types";

import {GameInfo} from "app/types/game";
import {Coin} from "app/types/user";
import {cryptoFullNameList} from "app/components";

import vipLevel0 from "app/assets/vipLevelIcon/level0.png";
import vipLevel1 from "app/assets/vipLevelIcon/level1.png";
import vipLevel2 from "app/assets/vipLevelIcon/level2.png";
import vipLevel3 from "app/assets/vipLevelIcon/level3.png";
import vipLevel4 from "app/assets/vipLevelIcon/level4.png";
import vipLevel5 from "app/assets/vipLevelIcon/level5.png";
import vipLevel6 from "app/assets/vipLevelIcon/level6.png";
import vipLevel7 from "app/assets/vipLevelIcon/level7.png";
import vipLevel8 from "app/assets/vipLevelIcon/level8.png";
import vipLevel9 from "app/assets/vipLevelIcon/level9.png";
import vipLevel10 from "app/assets/vipLevelIcon/level10.png";
import vipLevel11 from "app/assets/vipLevelIcon/level11.png";
import vipLevel12 from "app/assets/vipLevelIcon/level12.png";
import vipLevel13 from "app/assets/vipLevelIcon/level13.png";
import vipLevel14 from "app/assets/vipLevelIcon/level14.png";
import vipLevel15 from "app/assets/vipLevelIcon/level15.png";
import vipLevel16 from "app/assets/vipLevelIcon/level16.png";
import vipLevel17 from "app/assets/vipLevelIcon/level17.png";
import vipLevel18 from "app/assets/vipLevelIcon/level18.png";
import vipLevel19 from "app/assets/vipLevelIcon/level19.png";
import vipLevel20 from "app/assets/vipLevelIcon/level20.png";
import vipLevel21 from "app/assets/vipLevelIcon/level21.png";
import vipLevel22 from "app/assets/vipLevelIcon/level22.png";
import vipLevel23 from "app/assets/vipLevelIcon/level23.png";
import vipLevel24 from "app/assets/vipLevelIcon/level24.png";
import vipLevel25 from "app/assets/vipLevelIcon/level25.png";
import vipLevel26 from "app/assets/vipLevelIcon/level26.png";
import vipLevel27 from "app/assets/vipLevelIcon/level27.png";
import vipLevel28 from "app/assets/vipLevelIcon/level28.png";
import vipLevel29 from "app/assets/vipLevelIcon/level29.png";
import vipLevel30 from "app/assets/vipLevelIcon/level30.png";
import vipLevel31 from "app/assets/vipLevelIcon/level31.png";
import { config } from '../config.js';

const IMAGE_BASE_URL = config.image_base_url;

export const uint8ArrayToString = (fileData: Uint8Array) => {
    let dataString = "";
    for (let i = 0; i < fileData.length; i++) {
        dataString += String.fromCharCode(fileData[i]);
    }
    return dataString;
};

export const stringToUint8Array = (str: string) => {
    const arr = [];
    for (let i = 0, j = str.length; i < j; ++i) {
        arr.push(str.charCodeAt(i));
    }

    const tmpUint8Array = new Uint8Array(arr);
    return tmpUint8Array;
};

export const getVipLevelIcon = (level: number) => {
    const vipLevelList = [
        vipLevel1,
        vipLevel2,
        vipLevel3,
        vipLevel4,
        vipLevel5,
        vipLevel6,
        vipLevel7,
        vipLevel8,
        vipLevel9,
        vipLevel10,
        vipLevel11,
        vipLevel12,
        vipLevel13,
        vipLevel14,
        vipLevel15,
        vipLevel16,
        vipLevel17,
        vipLevel18,
        vipLevel19,
        vipLevel20,
        vipLevel21,
        vipLevel22,
        vipLevel23,
        vipLevel24,
        vipLevel25,
        vipLevel26,
        vipLevel27,
        vipLevel28,
        vipLevel29,
        vipLevel30,
        vipLevel31,
    ];
    if (level === undefined || level >= vipLevelList.length - 1) {
        return vipLevelList[0];
    }
    return vipLevelList[level];
};

export const getRewardLevelName = (val: string) => {
    if (val.toLocaleLowerCase() === "zero" || val.toLocaleLowerCase() === "rookie") {
        return "bronze";
    }

    return val;
};

export const getVipLevelString = (level: number) => {
    if (level <= 5) {
        return "bronze";
    }
    if (level <= 10) {
        return "silver";
    }
    if (level <= 15) {
        return "gold";
    }
    if (level <= 20) {
        return "platinum";
    }
    if (level <= 25) {
        return "pearl";
    }
    if (level <= 30) {
        return "onyx";
    }
    if (level <= 35) {
        return "diamond";
    }
    if (level <= 40) {
        return "palladium";
    }
    if (level <= 40) {
        return "castle";
    }
};

export const getGameLogoUrl = (game: GameInfo) => {
    const gameImgUrl = game.logoUrl || game.gameLogo || game.gameIcon || "";
    if (!gameImgUrl) {
        return "";
    }
    if (gameImgUrl.startsWith("/")) {
        return gameImgUrl;
    }
    if (game.gameInlineType === 1) {
        return config.image_base_url + game.logoUrl;
    }
    return gameImgUrl.startsWith("http") ? gameImgUrl : config.thirdparty_image_base_url + gameImgUrl;
};

export const getCurrencyIcon = (type: number | string) => {
    const _type = Number(type);
    return `${IMAGE_BASE_URL}images/platform/coin/${config.platform_id}/${_type}.png`;
};

export const toFixedSignificantDigit = (amount: number | string, size: number) => {
    const value = Number(amount || 0).toFixed(size);
    const index = value.indexOf(".");
    const high = index > 0 ? value.substring(0, index) : value;
    if (high.length > size + 1) {
        return value.substring(0, size + 1);
    }
    return `${Number(value).toFixed(Math.max(0, size - high.length))}`;
};

// export const base64Decode = (code: string) => {
//     return window.atob(code);
// };

export const toLocaleNumber = (
    num = 0,
    opt: any = {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: true,
    },
) => {
    return num.toLocaleString("en-US", opt);
};

export const gameHandler = (game: GameInfo) => {
    const temp = {...game};
    temp.additionalInfo = {
        activeUsers: Math.floor(Math.random() * (1000 - 100 + 1)) + 100,
    };
    return temp;
};

export const gameListHandler = (gameList: GameInfo[]) => {
    const list = [...gameList];
    list.forEach((v: GameInfo) => {
        v = gameHandler(v);
    });
    return list;
};

export const ChannelDisplayName: Record<string, string> = {
    d_gigadat: "Interac®",
    w_gigadat: "Interac®e-Transfer",
    d_toppaybrl: "toppay",
    w_toppaybrl: "toppay",
    d_astropaydir: "astropay-pix",
    w_astropaydir: "astropay-pix",
};

export const getCryptoFullName = (tokenName: string): string => {
    const match = cryptoFullNameList.find((crypto) => crypto.symbol === tokenName);
    return match ? match.fullName : tokenName;
};

export const getAvatarUrl = (url: string) => {
    if ((url || "").startsWith("http")) {
        return url;
    }
    return `${config.image_base_url}images/header/${url}.png`;
};

export const formatNumberToDecimal = (num: number, decimalLen = 6) => {
    const decimalPlaces = num.toString().split(".")[1]?.length || 0;
    if (decimalPlaces > decimalLen) {
        return num.toFixed(decimalLen);
    }
    return num;
};

export const getGameDetailUrl = (gameInfo: GameInfo, langNavigate: any) => {
    const providerName = (gameInfo.providerName || gameInfo.brand || "").toLowerCase().replace(/ /g, '-');
    const gameName = (gameInfo.gameName || "").toLowerCase().replace(/ /g, '-');
    const gameId = gameInfo.gameId;
    const gameUrl = `${gameName}-${providerName}-${gameId}`;

    return langNavigate("/game-detail/" + gameUrl);
};

export const getGameImageUrl = (game: GameInfo) => {
    return {
        default: `${config.image_optimized_base_url}format=avif,width=800/${game.gameId}.png`,
        optimizedSrc: undefined,
        // TODO: if image origin on cloudfire - this logic useless (if change image source - uncomment);
        // optimizedSrc: {
        //     avif: `${config.image_optimized_base_url}format=avif,width=800/${game.gameId}.png`,
        //     webp: `${config.image_optimized_base_url}format=webp,width=800/${game.gameId}.png`,
        // },
    };
};

export const getMappedCard = (game: GameInfo, langNavigate: any): ICardProps => {
    const url = getGameDetailUrl(game, langNavigate);
    return {
        ...game,
        showPlaceholder: false,
        imageLayers: {
            mediaImage: getGameImageUrl(game).default,
        },
        // optimizedSrc: getGameImageUrl(game).optimizedSrc,
        additionalInfo: undefined,
        type: "GAME_V2",
        id: game.gameId,
        index: game.gameId,
        key: game.gameId,
        href: url,
    };
};

export const getMappedCardList = (gameList: GameInfo[], langNavigate: any): ICardProps[] => {
    return gameList.map((v: GameInfo) => {
        return getMappedCard(v, langNavigate);
    });
};

export const getTodayAt0800GMT = () => {
    const now = new Date();
    return new Date(
        Date.UTC(
            now.getUTCFullYear(),
            now.getUTCMonth(),
            now.getUTCDate(),
            8, // 08:00 hours
            0, // 00 minutes
            0, // 00 seconds
        ),
    );
};

export const getTomorrowAt0800GMT = () => {
    const now = new Date();
    return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1, 8, 0, 0));
};

export const getUsd = (item: {value: string; tokenId: number}, balance: Coin[]) => {
    const rate = balance?.find((v) => v.type === item.tokenId)?.rate || 0;
    return toLocaleNumber(Number(item.value.replace(/,/g, "")) * rate, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 7,
        useGrouping: true,
    });
};

export const convertToFiat = (isFiat: boolean, tokenId: number, value: string, balance: Coin[]) => {
    return isFiat
        ? Number(
              getUsd(
                  {
                      tokenId: tokenId,
                      value: value || "0",
                  },
                  balance,
              ),
          )
        : Number(value);
};

export const fileToBase64: (file: File) => Promise<string | ArrayBuffer | null> = (file: File) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });

export const transactionLinkGenerator = (txid?: string, protocol?: string) => {
    if (!txid || !protocol) return "";

    const protocolUpper = protocol.toUpperCase();

    const explorerMap = {
        ERC20: "https://etherscan.io/tx/",
        ETH: "https://etherscan.io/tx/",
        BEP20: "https://bscscan.com/tx/",
        BNB: "https://bscscan.com/tx/",
        POLYGON: "https://polygonscan.com/tx/",
        ARBITRUM: "https://arbiscan.io/tx/",
        OPTIMISM: "https://optimistic.etherscan.io/tx/",
        BTC: "https://www.blockchain.com/btc/tx/",
        LTC: "https://blockchair.com/litecoin/transaction/",
        TRX: "https://tronscan.org/#/transaction/",
        SOLANA: "https://solscan.io/tx/",
        TRC20: "https://tronscan.org/#/transaction/"
    };

    const baseUrl = explorerMap[protocolUpper as keyof typeof explorerMap];
    return baseUrl ? `${baseUrl}${txid}` : "";
};
